import { ImagotipoDynamicDashboard, ImagotipoGondolaCold, ImagotipoHome, ImagotipoInventory, ImagotipoIvaCards, ImagotipoLogout, ImagotipoOrders, ImagotipoSellersControl, LogoHorizontalPremierTools } from "assets"
import { useAppDispatch, useAppSelector } from "hooks";
import { signOutSession } from "services";
import { PagesNames } from "types";
// import ImageCard from "assets/svg/onsix/card-icon.svg"
import { useNavigate } from "react-router-dom";
import DiscountIcon from '@mui/icons-material/Discount';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import CategoryIcon from '@mui/icons-material/Category';

interface MenuOption {
    icon: () => JSX.Element,
    title: string,
    route: string,
    permission: string,
}

const menuOptions: MenuOption[] = [
    {
        icon: ImagotipoDynamicDashboard,
        title: "Dashboard Dinámico",
        route: "/dashboard",
        permission: "dynamic_dashboard",
    }, {
        icon: ImagotipoSellersControl,
        title: "Control de Vendedores",
        route: "/sellersControl",
        permission: "sellers_control",
    }, {
        icon: ImagotipoGondolaCold,
        title: "Góndola y Frío",
        route: "/gondolaCold",
        permission: "gondola_cold",
    }, {
        icon: ImagotipoInventory,
        title: "Inventario",
        route: "/inventory",
        permission: "inventory",
    }, {
        icon: ImagotipoOrders,
        title: "Pedidos",
        route: "/orders",
        permission: "orders",
    }, {
        icon: ImagotipoIvaCards,
        title: "Tarjetas de I.V.A.",
        route: "/ivaCards",
        permission: "iva_cards",
    }, {
        icon: () => <CategoryIcon style={{ color: '#4B5563', width: '24px', height: '24px' }} />,
        title: "Administración de Categorías",
        route: "/administracionCategorias",
        permission: "benchmarks_report",
    }, {
        icon: () => <DiscountIcon style={{ color: '#4B5563', width: '24px', height: '24px' }} />,
        title: "Reporte de promociones",
        route: "/reportePromocion",
        permission: "benchmarks_report_promotions",
    }, {
        icon: () => <StarHalfIcon style={{ color: '#4B5563', width: '24px', height: '24px' }} />,
        title: "On6",
        route: "/on-six",
        permission: "on6",
    },
]


export const SidebarMenu = ({ pageName }: { pageName: PagesNames }) => {
    const { accessPermits } = useAppSelector(state => state.settings);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const renderOptions = () => {
        const options = menuOptions.map((option: MenuOption) => {
            if (accessPermits.includes(option.permission)) {
                return (
                    <div
                        key={option.route}
                        onClick={() => navigate(option.route)}
                        className="flex items-center gap-4 cursor-pointer"
                    >
                        <div className="flex items-center gap-2">
                            {
                                pageName === option.permission &&
                                <span className="text-secondary font-bold text-3xl"></span>
                            }

                            <div className={`p-2 flex items-center gap-1 ${pageName !== option.permission && "ml-5"} ${pageName === option.permission && 'bg-light border border-tertiary rounded-md'}`}>

                                {
                                    option.icon()
                                }
                            </div>
                        </div>

                        <p className={`text-md ${pageName === option.permission && "font-bold"} `}>{option.title}</p>
                    </div>
                )
            }
            return null
        });

        return options.filter(option => option !== null);
    };

    return (
        <div className="w-full overflow-auto overflow-x-hidden h-screen flex flex-col flex-grow gap-12 px-0 py-6 border-r-2 border-light">
            <div
                onClick={() => navigate("/home")}
                className="w-full flex justify-center cursor-pointer"
            >
                <LogoHorizontalPremierTools />
            </div>

            <div className="w-full flex flex-col gap-4">
                <div
                    onClick={() => navigate("/home")}
                    className="flex items-center gap-4 cursor-pointer" >
                    <div className="flex items-center gap-2">
                        {
                            pageName === "home" &&
                            <span className="text-secondary font-bold text-3xl">·</span>
                        }

                        <div className={`p-2 flex items-center gap-1 ${pageName !== "home" && "ml-5"} ${pageName === "home" && 'bg-light border border-tertiary rounded-md'}`}>
                            <ImagotipoHome />
                        </div>
                    </div>

                    <p className={`text-md ${pageName === "home" && "font-bold"}`}>Inicio</p>
                </div>

                {renderOptions()}
            </div>

            <div className="w-full mt-auto flex flex-col gap-4">
                <div
                    onClick={() => signOutSession(dispatch, navigate)}
                    className="flex items-center gap-4 cursor-pointer pt-2 border-t border-solid border-tertiary"
                >
                    <div className="flex items-center gap-2">
                        <div className={`p-2 flex items-center gap-1 ml-5`}>
                            <ImagotipoLogout />
                        </div>
                    </div>

                    <p className={`text-md`}>Cerrar Sesión</p>
                </div>

                <div className="pt-2 font-bold border-t border-solid border-tertiary">
                    <p className="ml-7 text-mid">V {process.env.REACT_APP_VERSION}</p>
                </div>
            </div>
        </div>
    )
}